import { z } from "zod";
import { listQuerySchema, optionalText, optionalUuid, priorityField, quantityField, } from "./common.js";
export const jobOperationInputSchema = z.object({
    sequence: z.number().int().min(0).max(1000).optional(),
    workCenterId: optionalUuid(),
    description: z.string().trim().min(1, "Operation description is required.").max(200),
    setupMinutes: z.number().min(0).max(100000).optional(),
    runMinutesPerUnit: z.number().min(0).max(100000).optional(),
});
export const jobMaterialInputSchema = z.object({
    materialId: z.string().uuid("Invalid material id."),
    plannedQuantity: z
        .string()
        .trim()
        .regex(/^\d+(\.\d{1,4})?$/, "Invalid quantity.")
        .refine((v) => Number(v) > 0, "Quantity must be greater than zero."),
});
export const jobCreateSchema = z.object({
    customerId: optionalUuid(),
    title: z.string().trim().min(1, "Job title is required.").max(160),
    description: optionalText(4000),
    quantity: quantityField,
    priority: z.enum(["low", "medium", "high"]).optional(),
    dueDate: z.string().date().optional(),
    operations: z.array(jobOperationInputSchema).max(50).optional(),
    materials: z.array(jobMaterialInputSchema).max(50).optional(),
});
export const jobHoldSchema = z.object({
    reason: z.string().trim().min(3, "A short reason is required.").max(500),
});
export const jobNoteSchema = z.object({
    note: z.string().trim().max(500).optional(),
});
export const jobCompleteSchema = z.object({
    force: z.boolean().default(false),
    note: z.string().trim().max(500).optional(),
});
export const jobIssueSchema = z.object({
    description: z.string().trim().min(1, "A description is required.").max(2000),
    severity: priorityField,
    jobOperationId: optionalUuid(),
});
export const jobResolveSchema = z.object({
    note: z.string().trim().max(500).optional(),
});
export const jobListQuerySchema = listQuerySchema.extend({
    status: z
        .enum([
        "draft",
        "planned",
        "released",
        "in_progress",
        "on_hold",
        "ready_for_delivery",
        "completed",
        "cancelled",
    ])
        .optional(),
    customerId: z.string().uuid().optional(),
    workCenterId: z.string().uuid().optional(),
    due: z.enum(["overdue", "due_soon", "all"]).optional(),
    search: z.string().trim().max(120).optional(),
});
export const jobIdParamSchema = z.object({
    id: z.string().uuid("Invalid job id."),
});
export const jobOperationIdParamSchema = z.object({
    id: z.string().uuid("Invalid job id."),
    operationId: z.string().uuid("Invalid operation id."),
});
export const jobIssueIdParamSchema = z.object({
    id: z.string().uuid("Invalid job id."),
    issueId: z.string().uuid("Invalid issue id."),
});
export const salesOrderConvertSchema = z.object({
    priority: priorityField,
    dueDate: z.string().date().optional(),
});
//# sourceMappingURL=jobs.js.map